export {
    decodeByte,
    decodeByteSlice,
    decodeInt8,
    decodeInt16,
    decodeInt32,
    decodeInt64,
    decodeUint8,
    decodeUint16,
    decodeUint32,
    decodeUint64,
    decodeVarint,
    decodeUvarint,
    decodeFloat32,
    decodeFloat64,
    decodeBool,
    decodeString,
    decodeTime
} from '../lib/Amino';
